import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const GetInsurancesBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetInsurances),
  config: z.object({}), // there are no configs for this block
  returnType: returnTypeSchema(ProducedType.Insurances),
});

export type GetInsurancesBlock = z.infer<typeof GetInsurancesBlockSchema>;
